const searchSuggestionsParams = {
    type: "all",
    start: "0",
    count: "7",
};

export async function getSearchSuggestions(
    searchSuggestionApiUrl: string,
    query: string,
    abortController: AbortController,
): Promise<SearchSuggestionsResponse | undefined> {
    const searchParams = new URLSearchParams(searchSuggestionsParams);
    searchParams.set("q", query);

    const url = new URL(searchSuggestionApiUrl);
    url.search = searchParams.toString();

    const fetchWithTimeout = async (fetchPromise: Promise<Response>, timeoutMs: number) => {
        const timeoutPromise = new Promise<Response | undefined>((resolve) =>
            setTimeout(() => resolve(undefined), timeoutMs)
        );
        return Promise.race([fetchPromise, timeoutPromise]);
    };

    try {
        const response = await fetchWithTimeout(fetch(url, { signal: abortController.signal }), 3000); // Timeout after 3 seconds
        if (!response) {
            // If the response is undefined, it means the request timed out or was aborted
            return undefined; // Return undefined if timeout occurs or request was aborted
        }

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
    } catch (error) {
        if( abortController.signal.aborted ) {
            // Request aborted due to updated search term
            return undefined
        }
        console.error("Error fetching search suggestions:", error);
        return undefined; // Return undefined for any other errors
    }
}

export interface SearchSuggestionsResponse {
    request: Request;
    total: number;
    start: string;
    count: number;
    counts: Counts;
    categories: string[];
    hits: Hit[];
}

export interface Request {
    params: Params;
}

export interface Params {
    q: string;
    type: string;
    start: string;
    count: string;
}

export interface Counts {
    all: number;
    content: number;
    unit: number;
    postalCode: number;
    address: number;
}

export interface Hit {
    _category: string;
    _hotlistType: string;
    _hotlistHeading: string;
    _type: string;
    absoluteUrl: string;
    heading: string;
    serverUrl: string;
    preface: string;
}
